export const OPTION_LAYOUT = {
    SINGLE_LINE: 'single-line',
    DOUBLE_LINE: 'double-line',
};
export const DATA_HOOKS = {
    MAIN_LABEL: 'main-label',
    SECONDARY_LABEL: 'secondary-label',
};
//# sourceMappingURL=constants.js.map